import React from "react";
import PropTypes from "prop-types";
import Banner from "@p1s/p1s-common-react/entities/Banner";
import DOMPurify from "dompurify";

export const MaintenanceBanner = ({ banner, className }) => {
    if (!banner || !banner.isActive)
        return (<div className="outageBanner-container"/>);

    const bannerClassName = className ?? "upcoming";

    const bannerIconClass = `maintenance-icon ${banner.iconClass}`;

    return (
        <div className="outageBanner-container">
            <div className="outageBanner">
                <div className={bannerClassName}>
                    <div className="maintenanceTitle">
                        <i className={bannerIconClass}/>
                        {banner.title}
                    </div>
                    <div className="banner-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(banner.text) }}/>
                </div>
            </div>
        </div>);
};

MaintenanceBanner.propTypes = {
    banner: PropTypes.instanceOf(Banner),
    className: PropTypes.string
};

export default MaintenanceBanner;
